module.exports = __webpack_public_path__ + "img/afm-desktop.b9525963.jpg";